export var AssetEntityOrderByInput;
(function (AssetEntityOrderByInput) {
    AssetEntityOrderByInput["DecimalsAsc"] = "decimals_ASC";
    AssetEntityOrderByInput["DecimalsDesc"] = "decimals_DESC";
    AssetEntityOrderByInput["IdAsc"] = "id_ASC";
    AssetEntityOrderByInput["IdDesc"] = "id_DESC";
    AssetEntityOrderByInput["NameAsc"] = "name_ASC";
    AssetEntityOrderByInput["NameDesc"] = "name_DESC";
    AssetEntityOrderByInput["SymbolAsc"] = "symbol_ASC";
    AssetEntityOrderByInput["SymbolDesc"] = "symbol_DESC";
})(AssetEntityOrderByInput || (AssetEntityOrderByInput = {}));
export var CollectionEntityOrderByInput;
(function (CollectionEntityOrderByInput) {
    CollectionEntityOrderByInput["BlockNumberAsc"] = "blockNumber_ASC";
    CollectionEntityOrderByInput["BlockNumberDesc"] = "blockNumber_DESC";
    CollectionEntityOrderByInput["BurnedAsc"] = "burned_ASC";
    CollectionEntityOrderByInput["BurnedDesc"] = "burned_DESC";
    CollectionEntityOrderByInput["CreatedAtAsc"] = "createdAt_ASC";
    CollectionEntityOrderByInput["CreatedAtDesc"] = "createdAt_DESC";
    CollectionEntityOrderByInput["CurrentOwnerAsc"] = "currentOwner_ASC";
    CollectionEntityOrderByInput["CurrentOwnerDesc"] = "currentOwner_DESC";
    CollectionEntityOrderByInput["DistributionAsc"] = "distribution_ASC";
    CollectionEntityOrderByInput["DistributionDesc"] = "distribution_DESC";
    CollectionEntityOrderByInput["FloorAsc"] = "floor_ASC";
    CollectionEntityOrderByInput["FloorDesc"] = "floor_DESC";
    CollectionEntityOrderByInput["HashAsc"] = "hash_ASC";
    CollectionEntityOrderByInput["HashDesc"] = "hash_DESC";
    CollectionEntityOrderByInput["HighestSaleAsc"] = "highestSale_ASC";
    CollectionEntityOrderByInput["HighestSaleDesc"] = "highestSale_DESC";
    CollectionEntityOrderByInput["IdAsc"] = "id_ASC";
    CollectionEntityOrderByInput["IdDesc"] = "id_DESC";
    CollectionEntityOrderByInput["ImageAsc"] = "image_ASC";
    CollectionEntityOrderByInput["ImageDesc"] = "image_DESC";
    CollectionEntityOrderByInput["IssuerAsc"] = "issuer_ASC";
    CollectionEntityOrderByInput["IssuerDesc"] = "issuer_DESC";
    CollectionEntityOrderByInput["MaxAsc"] = "max_ASC";
    CollectionEntityOrderByInput["MaxDesc"] = "max_DESC";
    CollectionEntityOrderByInput["MediaAsc"] = "media_ASC";
    CollectionEntityOrderByInput["MediaDesc"] = "media_DESC";
    CollectionEntityOrderByInput["MetaAnimationUrlAsc"] = "meta_animationUrl_ASC";
    CollectionEntityOrderByInput["MetaAnimationUrlDesc"] = "meta_animationUrl_DESC";
    CollectionEntityOrderByInput["MetaBannerAsc"] = "meta_banner_ASC";
    CollectionEntityOrderByInput["MetaBannerDesc"] = "meta_banner_DESC";
    CollectionEntityOrderByInput["MetaDescriptionAsc"] = "meta_description_ASC";
    CollectionEntityOrderByInput["MetaDescriptionDesc"] = "meta_description_DESC";
    CollectionEntityOrderByInput["MetaIdAsc"] = "meta_id_ASC";
    CollectionEntityOrderByInput["MetaIdDesc"] = "meta_id_DESC";
    CollectionEntityOrderByInput["MetaImageAsc"] = "meta_image_ASC";
    CollectionEntityOrderByInput["MetaImageDesc"] = "meta_image_DESC";
    CollectionEntityOrderByInput["MetaNameAsc"] = "meta_name_ASC";
    CollectionEntityOrderByInput["MetaNameDesc"] = "meta_name_DESC";
    CollectionEntityOrderByInput["MetaTypeAsc"] = "meta_type_ASC";
    CollectionEntityOrderByInput["MetaTypeDesc"] = "meta_type_DESC";
    CollectionEntityOrderByInput["MetadataAsc"] = "metadata_ASC";
    CollectionEntityOrderByInput["MetadataDesc"] = "metadata_DESC";
    CollectionEntityOrderByInput["NameAsc"] = "name_ASC";
    CollectionEntityOrderByInput["NameDesc"] = "name_DESC";
    CollectionEntityOrderByInput["NftCountAsc"] = "nftCount_ASC";
    CollectionEntityOrderByInput["NftCountDesc"] = "nftCount_DESC";
    CollectionEntityOrderByInput["OwnerCountAsc"] = "ownerCount_ASC";
    CollectionEntityOrderByInput["OwnerCountDesc"] = "ownerCount_DESC";
    CollectionEntityOrderByInput["RecipientAsc"] = "recipient_ASC";
    CollectionEntityOrderByInput["RecipientDesc"] = "recipient_DESC";
    CollectionEntityOrderByInput["RoyaltyAsc"] = "royalty_ASC";
    CollectionEntityOrderByInput["RoyaltyDesc"] = "royalty_DESC";
    CollectionEntityOrderByInput["SupplyAsc"] = "supply_ASC";
    CollectionEntityOrderByInput["SupplyDesc"] = "supply_DESC";
    CollectionEntityOrderByInput["UpdatedAtAsc"] = "updatedAt_ASC";
    CollectionEntityOrderByInput["UpdatedAtDesc"] = "updatedAt_DESC";
    CollectionEntityOrderByInput["VersionAsc"] = "version_ASC";
    CollectionEntityOrderByInput["VersionDesc"] = "version_DESC";
    CollectionEntityOrderByInput["VolumeAsc"] = "volume_ASC";
    CollectionEntityOrderByInput["VolumeDesc"] = "volume_DESC";
})(CollectionEntityOrderByInput || (CollectionEntityOrderByInput = {}));
export var CollectionEventOrderByInput;
(function (CollectionEventOrderByInput) {
    CollectionEventOrderByInput["BlockNumberAsc"] = "blockNumber_ASC";
    CollectionEventOrderByInput["BlockNumberDesc"] = "blockNumber_DESC";
    CollectionEventOrderByInput["CallerAsc"] = "caller_ASC";
    CollectionEventOrderByInput["CallerDesc"] = "caller_DESC";
    CollectionEventOrderByInput["CollectionBlockNumberAsc"] = "collection_blockNumber_ASC";
    CollectionEventOrderByInput["CollectionBlockNumberDesc"] = "collection_blockNumber_DESC";
    CollectionEventOrderByInput["CollectionBurnedAsc"] = "collection_burned_ASC";
    CollectionEventOrderByInput["CollectionBurnedDesc"] = "collection_burned_DESC";
    CollectionEventOrderByInput["CollectionCreatedAtAsc"] = "collection_createdAt_ASC";
    CollectionEventOrderByInput["CollectionCreatedAtDesc"] = "collection_createdAt_DESC";
    CollectionEventOrderByInput["CollectionCurrentOwnerAsc"] = "collection_currentOwner_ASC";
    CollectionEventOrderByInput["CollectionCurrentOwnerDesc"] = "collection_currentOwner_DESC";
    CollectionEventOrderByInput["CollectionDistributionAsc"] = "collection_distribution_ASC";
    CollectionEventOrderByInput["CollectionDistributionDesc"] = "collection_distribution_DESC";
    CollectionEventOrderByInput["CollectionFloorAsc"] = "collection_floor_ASC";
    CollectionEventOrderByInput["CollectionFloorDesc"] = "collection_floor_DESC";
    CollectionEventOrderByInput["CollectionHashAsc"] = "collection_hash_ASC";
    CollectionEventOrderByInput["CollectionHashDesc"] = "collection_hash_DESC";
    CollectionEventOrderByInput["CollectionHighestSaleAsc"] = "collection_highestSale_ASC";
    CollectionEventOrderByInput["CollectionHighestSaleDesc"] = "collection_highestSale_DESC";
    CollectionEventOrderByInput["CollectionIdAsc"] = "collection_id_ASC";
    CollectionEventOrderByInput["CollectionIdDesc"] = "collection_id_DESC";
    CollectionEventOrderByInput["CollectionImageAsc"] = "collection_image_ASC";
    CollectionEventOrderByInput["CollectionImageDesc"] = "collection_image_DESC";
    CollectionEventOrderByInput["CollectionIssuerAsc"] = "collection_issuer_ASC";
    CollectionEventOrderByInput["CollectionIssuerDesc"] = "collection_issuer_DESC";
    CollectionEventOrderByInput["CollectionMaxAsc"] = "collection_max_ASC";
    CollectionEventOrderByInput["CollectionMaxDesc"] = "collection_max_DESC";
    CollectionEventOrderByInput["CollectionMediaAsc"] = "collection_media_ASC";
    CollectionEventOrderByInput["CollectionMediaDesc"] = "collection_media_DESC";
    CollectionEventOrderByInput["CollectionMetadataAsc"] = "collection_metadata_ASC";
    CollectionEventOrderByInput["CollectionMetadataDesc"] = "collection_metadata_DESC";
    CollectionEventOrderByInput["CollectionNameAsc"] = "collection_name_ASC";
    CollectionEventOrderByInput["CollectionNameDesc"] = "collection_name_DESC";
    CollectionEventOrderByInput["CollectionNftCountAsc"] = "collection_nftCount_ASC";
    CollectionEventOrderByInput["CollectionNftCountDesc"] = "collection_nftCount_DESC";
    CollectionEventOrderByInput["CollectionOwnerCountAsc"] = "collection_ownerCount_ASC";
    CollectionEventOrderByInput["CollectionOwnerCountDesc"] = "collection_ownerCount_DESC";
    CollectionEventOrderByInput["CollectionRecipientAsc"] = "collection_recipient_ASC";
    CollectionEventOrderByInput["CollectionRecipientDesc"] = "collection_recipient_DESC";
    CollectionEventOrderByInput["CollectionRoyaltyAsc"] = "collection_royalty_ASC";
    CollectionEventOrderByInput["CollectionRoyaltyDesc"] = "collection_royalty_DESC";
    CollectionEventOrderByInput["CollectionSupplyAsc"] = "collection_supply_ASC";
    CollectionEventOrderByInput["CollectionSupplyDesc"] = "collection_supply_DESC";
    CollectionEventOrderByInput["CollectionUpdatedAtAsc"] = "collection_updatedAt_ASC";
    CollectionEventOrderByInput["CollectionUpdatedAtDesc"] = "collection_updatedAt_DESC";
    CollectionEventOrderByInput["CollectionVersionAsc"] = "collection_version_ASC";
    CollectionEventOrderByInput["CollectionVersionDesc"] = "collection_version_DESC";
    CollectionEventOrderByInput["CollectionVolumeAsc"] = "collection_volume_ASC";
    CollectionEventOrderByInput["CollectionVolumeDesc"] = "collection_volume_DESC";
    CollectionEventOrderByInput["CurrentOwnerAsc"] = "currentOwner_ASC";
    CollectionEventOrderByInput["CurrentOwnerDesc"] = "currentOwner_DESC";
    CollectionEventOrderByInput["IdAsc"] = "id_ASC";
    CollectionEventOrderByInput["IdDesc"] = "id_DESC";
    CollectionEventOrderByInput["InteractionAsc"] = "interaction_ASC";
    CollectionEventOrderByInput["InteractionDesc"] = "interaction_DESC";
    CollectionEventOrderByInput["MetaAsc"] = "meta_ASC";
    CollectionEventOrderByInput["MetaDesc"] = "meta_DESC";
    CollectionEventOrderByInput["TimestampAsc"] = "timestamp_ASC";
    CollectionEventOrderByInput["TimestampDesc"] = "timestamp_DESC";
})(CollectionEventOrderByInput || (CollectionEventOrderByInput = {}));
export var EventOrderByInput;
(function (EventOrderByInput) {
    EventOrderByInput["BlockNumberAsc"] = "blockNumber_ASC";
    EventOrderByInput["BlockNumberDesc"] = "blockNumber_DESC";
    EventOrderByInput["CallerAsc"] = "caller_ASC";
    EventOrderByInput["CallerDesc"] = "caller_DESC";
    EventOrderByInput["CurrentOwnerAsc"] = "currentOwner_ASC";
    EventOrderByInput["CurrentOwnerDesc"] = "currentOwner_DESC";
    EventOrderByInput["IdAsc"] = "id_ASC";
    EventOrderByInput["IdDesc"] = "id_DESC";
    EventOrderByInput["InteractionAsc"] = "interaction_ASC";
    EventOrderByInput["InteractionDesc"] = "interaction_DESC";
    EventOrderByInput["MetaAsc"] = "meta_ASC";
    EventOrderByInput["MetaDesc"] = "meta_DESC";
    EventOrderByInput["NftBlockNumberAsc"] = "nft_blockNumber_ASC";
    EventOrderByInput["NftBlockNumberDesc"] = "nft_blockNumber_DESC";
    EventOrderByInput["NftBurnedAsc"] = "nft_burned_ASC";
    EventOrderByInput["NftBurnedDesc"] = "nft_burned_DESC";
    EventOrderByInput["NftCreatedAtAsc"] = "nft_createdAt_ASC";
    EventOrderByInput["NftCreatedAtDesc"] = "nft_createdAt_DESC";
    EventOrderByInput["NftCurrentOwnerAsc"] = "nft_currentOwner_ASC";
    EventOrderByInput["NftCurrentOwnerDesc"] = "nft_currentOwner_DESC";
    EventOrderByInput["NftHashAsc"] = "nft_hash_ASC";
    EventOrderByInput["NftHashDesc"] = "nft_hash_DESC";
    EventOrderByInput["NftIdAsc"] = "nft_id_ASC";
    EventOrderByInput["NftIdDesc"] = "nft_id_DESC";
    EventOrderByInput["NftImageAsc"] = "nft_image_ASC";
    EventOrderByInput["NftImageDesc"] = "nft_image_DESC";
    EventOrderByInput["NftIssuerAsc"] = "nft_issuer_ASC";
    EventOrderByInput["NftIssuerDesc"] = "nft_issuer_DESC";
    EventOrderByInput["NftLewdAsc"] = "nft_lewd_ASC";
    EventOrderByInput["NftLewdDesc"] = "nft_lewd_DESC";
    EventOrderByInput["NftMediaAsc"] = "nft_media_ASC";
    EventOrderByInput["NftMediaDesc"] = "nft_media_DESC";
    EventOrderByInput["NftMetadataAsc"] = "nft_metadata_ASC";
    EventOrderByInput["NftMetadataDesc"] = "nft_metadata_DESC";
    EventOrderByInput["NftNameAsc"] = "nft_name_ASC";
    EventOrderByInput["NftNameDesc"] = "nft_name_DESC";
    EventOrderByInput["NftPriceAsc"] = "nft_price_ASC";
    EventOrderByInput["NftPriceDesc"] = "nft_price_DESC";
    EventOrderByInput["NftRecipientAsc"] = "nft_recipient_ASC";
    EventOrderByInput["NftRecipientDesc"] = "nft_recipient_DESC";
    EventOrderByInput["NftRoyaltyAsc"] = "nft_royalty_ASC";
    EventOrderByInput["NftRoyaltyDesc"] = "nft_royalty_DESC";
    EventOrderByInput["NftSnAsc"] = "nft_sn_ASC";
    EventOrderByInput["NftSnDesc"] = "nft_sn_DESC";
    EventOrderByInput["NftUpdatedAtAsc"] = "nft_updatedAt_ASC";
    EventOrderByInput["NftUpdatedAtDesc"] = "nft_updatedAt_DESC";
    EventOrderByInput["NftVersionAsc"] = "nft_version_ASC";
    EventOrderByInput["NftVersionDesc"] = "nft_version_DESC";
    EventOrderByInput["TimestampAsc"] = "timestamp_ASC";
    EventOrderByInput["TimestampDesc"] = "timestamp_DESC";
})(EventOrderByInput || (EventOrderByInput = {}));
export var Interaction;
(function (Interaction) {
    Interaction["Burn"] = "BURN";
    Interaction["Buy"] = "BUY";
    Interaction["Changeissuer"] = "CHANGEISSUER";
    Interaction["Create"] = "CREATE";
    Interaction["Destroy"] = "DESTROY";
    Interaction["List"] = "LIST";
    Interaction["Lock"] = "LOCK";
    Interaction["Mint"] = "MINT";
    Interaction["Send"] = "SEND";
    Interaction["Unlist"] = "UNLIST";
})(Interaction || (Interaction = {}));
export var MetadataEntityOrderByInput;
(function (MetadataEntityOrderByInput) {
    MetadataEntityOrderByInput["AnimationUrlAsc"] = "animationUrl_ASC";
    MetadataEntityOrderByInput["AnimationUrlDesc"] = "animationUrl_DESC";
    MetadataEntityOrderByInput["BannerAsc"] = "banner_ASC";
    MetadataEntityOrderByInput["BannerDesc"] = "banner_DESC";
    MetadataEntityOrderByInput["DescriptionAsc"] = "description_ASC";
    MetadataEntityOrderByInput["DescriptionDesc"] = "description_DESC";
    MetadataEntityOrderByInput["IdAsc"] = "id_ASC";
    MetadataEntityOrderByInput["IdDesc"] = "id_DESC";
    MetadataEntityOrderByInput["ImageAsc"] = "image_ASC";
    MetadataEntityOrderByInput["ImageDesc"] = "image_DESC";
    MetadataEntityOrderByInput["NameAsc"] = "name_ASC";
    MetadataEntityOrderByInput["NameDesc"] = "name_DESC";
    MetadataEntityOrderByInput["TypeAsc"] = "type_ASC";
    MetadataEntityOrderByInput["TypeDesc"] = "type_DESC";
})(MetadataEntityOrderByInput || (MetadataEntityOrderByInput = {}));
export var NftEntityOrderByInput;
(function (NftEntityOrderByInput) {
    NftEntityOrderByInput["BlockNumberAsc"] = "blockNumber_ASC";
    NftEntityOrderByInput["BlockNumberDesc"] = "blockNumber_DESC";
    NftEntityOrderByInput["BurnedAsc"] = "burned_ASC";
    NftEntityOrderByInput["BurnedDesc"] = "burned_DESC";
    NftEntityOrderByInput["CollectionBlockNumberAsc"] = "collection_blockNumber_ASC";
    NftEntityOrderByInput["CollectionBlockNumberDesc"] = "collection_blockNumber_DESC";
    NftEntityOrderByInput["CollectionBurnedAsc"] = "collection_burned_ASC";
    NftEntityOrderByInput["CollectionBurnedDesc"] = "collection_burned_DESC";
    NftEntityOrderByInput["CollectionCreatedAtAsc"] = "collection_createdAt_ASC";
    NftEntityOrderByInput["CollectionCreatedAtDesc"] = "collection_createdAt_DESC";
    NftEntityOrderByInput["CollectionCurrentOwnerAsc"] = "collection_currentOwner_ASC";
    NftEntityOrderByInput["CollectionCurrentOwnerDesc"] = "collection_currentOwner_DESC";
    NftEntityOrderByInput["CollectionDistributionAsc"] = "collection_distribution_ASC";
    NftEntityOrderByInput["CollectionDistributionDesc"] = "collection_distribution_DESC";
    NftEntityOrderByInput["CollectionFloorAsc"] = "collection_floor_ASC";
    NftEntityOrderByInput["CollectionFloorDesc"] = "collection_floor_DESC";
    NftEntityOrderByInput["CollectionHashAsc"] = "collection_hash_ASC";
    NftEntityOrderByInput["CollectionHashDesc"] = "collection_hash_DESC";
    NftEntityOrderByInput["CollectionHighestSaleAsc"] = "collection_highestSale_ASC";
    NftEntityOrderByInput["CollectionHighestSaleDesc"] = "collection_highestSale_DESC";
    NftEntityOrderByInput["CollectionIdAsc"] = "collection_id_ASC";
    NftEntityOrderByInput["CollectionIdDesc"] = "collection_id_DESC";
    NftEntityOrderByInput["CollectionImageAsc"] = "collection_image_ASC";
    NftEntityOrderByInput["CollectionImageDesc"] = "collection_image_DESC";
    NftEntityOrderByInput["CollectionIssuerAsc"] = "collection_issuer_ASC";
    NftEntityOrderByInput["CollectionIssuerDesc"] = "collection_issuer_DESC";
    NftEntityOrderByInput["CollectionMaxAsc"] = "collection_max_ASC";
    NftEntityOrderByInput["CollectionMaxDesc"] = "collection_max_DESC";
    NftEntityOrderByInput["CollectionMediaAsc"] = "collection_media_ASC";
    NftEntityOrderByInput["CollectionMediaDesc"] = "collection_media_DESC";
    NftEntityOrderByInput["CollectionMetadataAsc"] = "collection_metadata_ASC";
    NftEntityOrderByInput["CollectionMetadataDesc"] = "collection_metadata_DESC";
    NftEntityOrderByInput["CollectionNameAsc"] = "collection_name_ASC";
    NftEntityOrderByInput["CollectionNameDesc"] = "collection_name_DESC";
    NftEntityOrderByInput["CollectionNftCountAsc"] = "collection_nftCount_ASC";
    NftEntityOrderByInput["CollectionNftCountDesc"] = "collection_nftCount_DESC";
    NftEntityOrderByInput["CollectionOwnerCountAsc"] = "collection_ownerCount_ASC";
    NftEntityOrderByInput["CollectionOwnerCountDesc"] = "collection_ownerCount_DESC";
    NftEntityOrderByInput["CollectionRecipientAsc"] = "collection_recipient_ASC";
    NftEntityOrderByInput["CollectionRecipientDesc"] = "collection_recipient_DESC";
    NftEntityOrderByInput["CollectionRoyaltyAsc"] = "collection_royalty_ASC";
    NftEntityOrderByInput["CollectionRoyaltyDesc"] = "collection_royalty_DESC";
    NftEntityOrderByInput["CollectionSupplyAsc"] = "collection_supply_ASC";
    NftEntityOrderByInput["CollectionSupplyDesc"] = "collection_supply_DESC";
    NftEntityOrderByInput["CollectionUpdatedAtAsc"] = "collection_updatedAt_ASC";
    NftEntityOrderByInput["CollectionUpdatedAtDesc"] = "collection_updatedAt_DESC";
    NftEntityOrderByInput["CollectionVersionAsc"] = "collection_version_ASC";
    NftEntityOrderByInput["CollectionVersionDesc"] = "collection_version_DESC";
    NftEntityOrderByInput["CollectionVolumeAsc"] = "collection_volume_ASC";
    NftEntityOrderByInput["CollectionVolumeDesc"] = "collection_volume_DESC";
    NftEntityOrderByInput["CreatedAtAsc"] = "createdAt_ASC";
    NftEntityOrderByInput["CreatedAtDesc"] = "createdAt_DESC";
    NftEntityOrderByInput["CurrentOwnerAsc"] = "currentOwner_ASC";
    NftEntityOrderByInput["CurrentOwnerDesc"] = "currentOwner_DESC";
    NftEntityOrderByInput["HashAsc"] = "hash_ASC";
    NftEntityOrderByInput["HashDesc"] = "hash_DESC";
    NftEntityOrderByInput["IdAsc"] = "id_ASC";
    NftEntityOrderByInput["IdDesc"] = "id_DESC";
    NftEntityOrderByInput["ImageAsc"] = "image_ASC";
    NftEntityOrderByInput["ImageDesc"] = "image_DESC";
    NftEntityOrderByInput["IssuerAsc"] = "issuer_ASC";
    NftEntityOrderByInput["IssuerDesc"] = "issuer_DESC";
    NftEntityOrderByInput["LewdAsc"] = "lewd_ASC";
    NftEntityOrderByInput["LewdDesc"] = "lewd_DESC";
    NftEntityOrderByInput["MediaAsc"] = "media_ASC";
    NftEntityOrderByInput["MediaDesc"] = "media_DESC";
    NftEntityOrderByInput["MetaAnimationUrlAsc"] = "meta_animationUrl_ASC";
    NftEntityOrderByInput["MetaAnimationUrlDesc"] = "meta_animationUrl_DESC";
    NftEntityOrderByInput["MetaBannerAsc"] = "meta_banner_ASC";
    NftEntityOrderByInput["MetaBannerDesc"] = "meta_banner_DESC";
    NftEntityOrderByInput["MetaDescriptionAsc"] = "meta_description_ASC";
    NftEntityOrderByInput["MetaDescriptionDesc"] = "meta_description_DESC";
    NftEntityOrderByInput["MetaIdAsc"] = "meta_id_ASC";
    NftEntityOrderByInput["MetaIdDesc"] = "meta_id_DESC";
    NftEntityOrderByInput["MetaImageAsc"] = "meta_image_ASC";
    NftEntityOrderByInput["MetaImageDesc"] = "meta_image_DESC";
    NftEntityOrderByInput["MetaNameAsc"] = "meta_name_ASC";
    NftEntityOrderByInput["MetaNameDesc"] = "meta_name_DESC";
    NftEntityOrderByInput["MetaTypeAsc"] = "meta_type_ASC";
    NftEntityOrderByInput["MetaTypeDesc"] = "meta_type_DESC";
    NftEntityOrderByInput["MetadataAsc"] = "metadata_ASC";
    NftEntityOrderByInput["MetadataDesc"] = "metadata_DESC";
    NftEntityOrderByInput["NameAsc"] = "name_ASC";
    NftEntityOrderByInput["NameDesc"] = "name_DESC";
    NftEntityOrderByInput["PriceAsc"] = "price_ASC";
    NftEntityOrderByInput["PriceDesc"] = "price_DESC";
    NftEntityOrderByInput["RecipientAsc"] = "recipient_ASC";
    NftEntityOrderByInput["RecipientDesc"] = "recipient_DESC";
    NftEntityOrderByInput["RoyaltyAsc"] = "royalty_ASC";
    NftEntityOrderByInput["RoyaltyDesc"] = "royalty_DESC";
    NftEntityOrderByInput["SnAsc"] = "sn_ASC";
    NftEntityOrderByInput["SnDesc"] = "sn_DESC";
    NftEntityOrderByInput["TokenBlockNumberAsc"] = "token_blockNumber_ASC";
    NftEntityOrderByInput["TokenBlockNumberDesc"] = "token_blockNumber_DESC";
    NftEntityOrderByInput["TokenCountAsc"] = "token_count_ASC";
    NftEntityOrderByInput["TokenCountDesc"] = "token_count_DESC";
    NftEntityOrderByInput["TokenCreatedAtAsc"] = "token_createdAt_ASC";
    NftEntityOrderByInput["TokenCreatedAtDesc"] = "token_createdAt_DESC";
    NftEntityOrderByInput["TokenHashAsc"] = "token_hash_ASC";
    NftEntityOrderByInput["TokenHashDesc"] = "token_hash_DESC";
    NftEntityOrderByInput["TokenIdAsc"] = "token_id_ASC";
    NftEntityOrderByInput["TokenIdDesc"] = "token_id_DESC";
    NftEntityOrderByInput["TokenImageAsc"] = "token_image_ASC";
    NftEntityOrderByInput["TokenImageDesc"] = "token_image_DESC";
    NftEntityOrderByInput["TokenMediaAsc"] = "token_media_ASC";
    NftEntityOrderByInput["TokenMediaDesc"] = "token_media_DESC";
    NftEntityOrderByInput["TokenMetadataAsc"] = "token_metadata_ASC";
    NftEntityOrderByInput["TokenMetadataDesc"] = "token_metadata_DESC";
    NftEntityOrderByInput["TokenNameAsc"] = "token_name_ASC";
    NftEntityOrderByInput["TokenNameDesc"] = "token_name_DESC";
    NftEntityOrderByInput["TokenSupplyAsc"] = "token_supply_ASC";
    NftEntityOrderByInput["TokenSupplyDesc"] = "token_supply_DESC";
    NftEntityOrderByInput["TokenUpdatedAtAsc"] = "token_updatedAt_ASC";
    NftEntityOrderByInput["TokenUpdatedAtDesc"] = "token_updatedAt_DESC";
    NftEntityOrderByInput["UpdatedAtAsc"] = "updatedAt_ASC";
    NftEntityOrderByInput["UpdatedAtDesc"] = "updatedAt_DESC";
    NftEntityOrderByInput["VersionAsc"] = "version_ASC";
    NftEntityOrderByInput["VersionDesc"] = "version_DESC";
})(NftEntityOrderByInput || (NftEntityOrderByInput = {}));
export var TokenEntityOrderByInput;
(function (TokenEntityOrderByInput) {
    TokenEntityOrderByInput["BlockNumberAsc"] = "blockNumber_ASC";
    TokenEntityOrderByInput["BlockNumberDesc"] = "blockNumber_DESC";
    TokenEntityOrderByInput["CollectionBlockNumberAsc"] = "collection_blockNumber_ASC";
    TokenEntityOrderByInput["CollectionBlockNumberDesc"] = "collection_blockNumber_DESC";
    TokenEntityOrderByInput["CollectionBurnedAsc"] = "collection_burned_ASC";
    TokenEntityOrderByInput["CollectionBurnedDesc"] = "collection_burned_DESC";
    TokenEntityOrderByInput["CollectionCreatedAtAsc"] = "collection_createdAt_ASC";
    TokenEntityOrderByInput["CollectionCreatedAtDesc"] = "collection_createdAt_DESC";
    TokenEntityOrderByInput["CollectionCurrentOwnerAsc"] = "collection_currentOwner_ASC";
    TokenEntityOrderByInput["CollectionCurrentOwnerDesc"] = "collection_currentOwner_DESC";
    TokenEntityOrderByInput["CollectionDistributionAsc"] = "collection_distribution_ASC";
    TokenEntityOrderByInput["CollectionDistributionDesc"] = "collection_distribution_DESC";
    TokenEntityOrderByInput["CollectionFloorAsc"] = "collection_floor_ASC";
    TokenEntityOrderByInput["CollectionFloorDesc"] = "collection_floor_DESC";
    TokenEntityOrderByInput["CollectionHashAsc"] = "collection_hash_ASC";
    TokenEntityOrderByInput["CollectionHashDesc"] = "collection_hash_DESC";
    TokenEntityOrderByInput["CollectionHighestSaleAsc"] = "collection_highestSale_ASC";
    TokenEntityOrderByInput["CollectionHighestSaleDesc"] = "collection_highestSale_DESC";
    TokenEntityOrderByInput["CollectionIdAsc"] = "collection_id_ASC";
    TokenEntityOrderByInput["CollectionIdDesc"] = "collection_id_DESC";
    TokenEntityOrderByInput["CollectionImageAsc"] = "collection_image_ASC";
    TokenEntityOrderByInput["CollectionImageDesc"] = "collection_image_DESC";
    TokenEntityOrderByInput["CollectionIssuerAsc"] = "collection_issuer_ASC";
    TokenEntityOrderByInput["CollectionIssuerDesc"] = "collection_issuer_DESC";
    TokenEntityOrderByInput["CollectionMaxAsc"] = "collection_max_ASC";
    TokenEntityOrderByInput["CollectionMaxDesc"] = "collection_max_DESC";
    TokenEntityOrderByInput["CollectionMediaAsc"] = "collection_media_ASC";
    TokenEntityOrderByInput["CollectionMediaDesc"] = "collection_media_DESC";
    TokenEntityOrderByInput["CollectionMetadataAsc"] = "collection_metadata_ASC";
    TokenEntityOrderByInput["CollectionMetadataDesc"] = "collection_metadata_DESC";
    TokenEntityOrderByInput["CollectionNameAsc"] = "collection_name_ASC";
    TokenEntityOrderByInput["CollectionNameDesc"] = "collection_name_DESC";
    TokenEntityOrderByInput["CollectionNftCountAsc"] = "collection_nftCount_ASC";
    TokenEntityOrderByInput["CollectionNftCountDesc"] = "collection_nftCount_DESC";
    TokenEntityOrderByInput["CollectionOwnerCountAsc"] = "collection_ownerCount_ASC";
    TokenEntityOrderByInput["CollectionOwnerCountDesc"] = "collection_ownerCount_DESC";
    TokenEntityOrderByInput["CollectionRecipientAsc"] = "collection_recipient_ASC";
    TokenEntityOrderByInput["CollectionRecipientDesc"] = "collection_recipient_DESC";
    TokenEntityOrderByInput["CollectionRoyaltyAsc"] = "collection_royalty_ASC";
    TokenEntityOrderByInput["CollectionRoyaltyDesc"] = "collection_royalty_DESC";
    TokenEntityOrderByInput["CollectionSupplyAsc"] = "collection_supply_ASC";
    TokenEntityOrderByInput["CollectionSupplyDesc"] = "collection_supply_DESC";
    TokenEntityOrderByInput["CollectionUpdatedAtAsc"] = "collection_updatedAt_ASC";
    TokenEntityOrderByInput["CollectionUpdatedAtDesc"] = "collection_updatedAt_DESC";
    TokenEntityOrderByInput["CollectionVersionAsc"] = "collection_version_ASC";
    TokenEntityOrderByInput["CollectionVersionDesc"] = "collection_version_DESC";
    TokenEntityOrderByInput["CollectionVolumeAsc"] = "collection_volume_ASC";
    TokenEntityOrderByInput["CollectionVolumeDesc"] = "collection_volume_DESC";
    TokenEntityOrderByInput["CountAsc"] = "count_ASC";
    TokenEntityOrderByInput["CountDesc"] = "count_DESC";
    TokenEntityOrderByInput["CreatedAtAsc"] = "createdAt_ASC";
    TokenEntityOrderByInput["CreatedAtDesc"] = "createdAt_DESC";
    TokenEntityOrderByInput["HashAsc"] = "hash_ASC";
    TokenEntityOrderByInput["HashDesc"] = "hash_DESC";
    TokenEntityOrderByInput["IdAsc"] = "id_ASC";
    TokenEntityOrderByInput["IdDesc"] = "id_DESC";
    TokenEntityOrderByInput["ImageAsc"] = "image_ASC";
    TokenEntityOrderByInput["ImageDesc"] = "image_DESC";
    TokenEntityOrderByInput["MediaAsc"] = "media_ASC";
    TokenEntityOrderByInput["MediaDesc"] = "media_DESC";
    TokenEntityOrderByInput["MetaAnimationUrlAsc"] = "meta_animationUrl_ASC";
    TokenEntityOrderByInput["MetaAnimationUrlDesc"] = "meta_animationUrl_DESC";
    TokenEntityOrderByInput["MetaBannerAsc"] = "meta_banner_ASC";
    TokenEntityOrderByInput["MetaBannerDesc"] = "meta_banner_DESC";
    TokenEntityOrderByInput["MetaDescriptionAsc"] = "meta_description_ASC";
    TokenEntityOrderByInput["MetaDescriptionDesc"] = "meta_description_DESC";
    TokenEntityOrderByInput["MetaIdAsc"] = "meta_id_ASC";
    TokenEntityOrderByInput["MetaIdDesc"] = "meta_id_DESC";
    TokenEntityOrderByInput["MetaImageAsc"] = "meta_image_ASC";
    TokenEntityOrderByInput["MetaImageDesc"] = "meta_image_DESC";
    TokenEntityOrderByInput["MetaNameAsc"] = "meta_name_ASC";
    TokenEntityOrderByInput["MetaNameDesc"] = "meta_name_DESC";
    TokenEntityOrderByInput["MetaTypeAsc"] = "meta_type_ASC";
    TokenEntityOrderByInput["MetaTypeDesc"] = "meta_type_DESC";
    TokenEntityOrderByInput["MetadataAsc"] = "metadata_ASC";
    TokenEntityOrderByInput["MetadataDesc"] = "metadata_DESC";
    TokenEntityOrderByInput["NameAsc"] = "name_ASC";
    TokenEntityOrderByInput["NameDesc"] = "name_DESC";
    TokenEntityOrderByInput["SupplyAsc"] = "supply_ASC";
    TokenEntityOrderByInput["SupplyDesc"] = "supply_DESC";
    TokenEntityOrderByInput["UpdatedAtAsc"] = "updatedAt_ASC";
    TokenEntityOrderByInput["UpdatedAtDesc"] = "updatedAt_DESC";
})(TokenEntityOrderByInput || (TokenEntityOrderByInput = {}));
export const CollectionListWithSearchDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'collectionListWithSearch' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
                    type: {
                        kind: 'ListType',
                        type: {
                            kind: 'NonNullType',
                            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CollectionEntityOrderByInput' } },
                        },
                    },
                    defaultValue: { kind: 'ListValue', values: [{ kind: 'EnumValue', value: 'blockNumber_DESC' }] },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'address' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'collections' },
                        name: { kind: 'Name', value: 'collectionEntities' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'offset' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'orderBy' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'nfts_some' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: 'burned_eq' },
                                                        value: { kind: 'BooleanValue', value: false },
                                                    },
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: 'currentOwner_eq' },
                                                        value: { kind: 'Variable', name: { kind: 'Name', value: 'address' } },
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'max' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'nfts' },
                                    arguments: [
                                        {
                                            kind: 'Argument',
                                            name: { kind: 'Name', value: 'where' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: 'burned_eq' },
                                                        value: { kind: 'BooleanValue', value: false },
                                                    },
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: 'currentOwner_eq' },
                                                        value: { kind: 'Variable', name: { kind: 'Name', value: 'address' } },
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'sn' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'currentOwner' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'meta' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'image' } },
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'attributes' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    { kind: 'Field', name: { kind: 'Name', value: 'trait' } },
                                                                    { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                                                ],
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
//# sourceMappingURL=graphql.js.map